/**
 * Authentication helper for API client
 * Updates the API client with authentication tokens
 */

import { apiClient } from './client';

let currentToken: string | null = null;

/**
 * Update API client with authentication token
 */
export function updateApiClientAuth(token: string | null) {
	currentToken = token;

	if (token) {
		// Set the security data for the API client
		apiClient.setSecurityData(token);
	} else {
		// Clear the security data
		apiClient.setSecurityData(null);
	}
}

/**
 * Get current authentication status
 */
export function getApiClientAuthStatus(): boolean {
	return currentToken != null;
}
